export default {
  dbl_filter_user_filter: '用户筛选器',
  dbl_filter_user_filters_label: '用户筛选器',
  dbl_filter_user_filters: '用户筛选器',
  dbl_filter_add_control_group: '添加对照组',
  dbl_filter_user_filter_setting: '用户筛选器设置',
  dbl_filter_add_new_filter: '添加新条件',
  dbl_filter_user_property: '用户属性',
  dbl_filter_conditions: '条件',
  dbl_filter_value: '值',
  dbl_filter_number: '数值',
  dbl_filter_please_select_user_property_first: '请先选择用户属性',
  dbl_filter_filter_set_up: '筛选器设置',
  dbl_filter_general_filter: '筛选器',
  dbl_filter_comparison: '对照组',
  dbl_filter_max_filters_reached: '最多添加5个筛选器',
  dbl_filter_user_filter_invalid: '请先添加数据源。',
  dbl_filter_user_filter_effective: '用户筛选器无效。数据集缺少用户属性，请联系v_blljli寻求帮助。',
  dbl_filter_all_users_add: '所有用户都已存在，不允许重复添加',
  dbl_filter_add_control_group_disabled: '最多可添加4个对照组',
  // 组件中已使用的 key
  dbl_filter_tab_current_filter: '筛选',
  dbl_filter_tab_my_favorite: '我的收藏',
  dbl_filter_complete_current_filter: '请完成当前筛选条件',
  dbl_filter_clear: '清空',
  dbl_filter_favorite: '收藏',
  dbl_filter_control_group_index: '对照组{index}：',
  dbl_filter_collapse_expand_filter: '折叠/展开筛选器',
  dbl_filter_more_filter: '更多筛选器',
  dbl_filter_collapse_filter: '折叠筛选器',
  dbl_filter_collapse_expand_filter_tips: '启用后，筛选器将默认单行显示，超出部分可点击“更多筛选”展开。',
  dbl_filter_filter_set_up_not_supported: '当前游戏不支持筛选器设置。',
};
